// extracted by mini-css-extract-plugin
export default {"mainContainer":"profile_mainContainer__tA6oP","mainContent":"profile_mainContent__5J+tx"};